export default {
  1: function(nextStepIndex, element, steps){

    switch(nextStepIndex){
      case 2:
        let start = document.querySelector('#btn-start');
        start.addEventListener("click", () => {
          steps.introJs.nextStep();
        });
        return 'disable';
      case 4:
        var clickFunction = function (event) {
          if(event.target.tagName === 'SPAN'){
            setTimeout(() => steps.introJs.nextStep(), 500);
            element.removeEventListener('click',clickFunction, false);
          }
        };
        element.addEventListener('click', clickFunction, false);
        return 'disable';
      case 6:
        return 'disable';
      default:
        return;
    }
  },
  2: function(nextStepIndex, element, steps, domRefs){

    function highlightWords(words){
      setTimeout(() => {
        words.forEach((word) => word.classList.add('animated', 'bounce'));
        setTimeout(() => {
          words.forEach((word) => {
            word.classList.add('highlight');
            word.classList.remove('animated', 'bounce');
          });
        }, 1000);
      }, 500)
    }

    function wrap(eles, wrapper){
      eles[0].insertAdjacentElement('beforebegin', wrapper);
      eles.forEach((ele) => wrapper.appendChild(ele));
    }

    switch(nextStepIndex){
      case 0:
        //Interval needed as start button doesn't immediately render on change
        //Check for button and try to click, and clear once found or after 11 tries;
        let intervalCounter = 0;
        const checkForStartBtn = setInterval(() => {
          intervalCounter++;
          const startBtn = document.querySelector('#btn-start');
          if(startBtn){
            startBtn.click();
            clearInterval(checkForStartBtn);
          }
          if(intervalCounter > 10)
            clearInterval(checkForStartBtn);
        }, 250);

        break;
      case 1:
        domRefs.lines = document.querySelectorAll('.poem .line:nth-of-type(-n+10)');
        let wrapper = document.createElement('div');
        wrapper.setAttribute('id', 'block1');
        wrap(domRefs.lines, wrapper);
        break;
      case 3:
        highlightWords([domRefs.lines[3].children[7], domRefs.lines[8].children[4]]);
        break;
      case 4:
        [domRefs.lines[3].children[7], domRefs.lines[8].children[4]].forEach((old) => old.classList.remove('highlight'));
        domRefs.wordWrapper = document.createElement('span');
        domRefs.wordWrapper.setAttribute('style', 'display: inline-block; transition: 2s');
        let eles = [...domRefs.lines[4].children].slice(0, 4);
        wrap(eles, domRefs.wordWrapper);
        highlightWords([domRefs.lines[0].children[0], domRefs.wordWrapper]);
        break;
      case 5:
        [domRefs.lines[0].children[0], domRefs.wordWrapper].forEach((old) => old.classList.remove('highlight'));
        setTimeout(() => domRefs.lines[3].lastChild.click(), 1000);
        break;
      default:
        return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Tutorial/tut_scripts.js